export default __webpack_public_path__ + "static/media/chair.412b9c5b.png";